import * as React from 'react';
import { Provider } from 'react-redux';

import {App} from './app';
import {GlobalStore} from '../model/redux/store';


export class ReduxRoot extends React.Component<any, any> {
    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            // routes order from parent to child routes, so last route is most nested route.
            let route = nextProps.routes[this.props.routes.length - 1];
            if (route.onEnter) {
                route.onEnter({
                    params: nextProps.params,
                    location: { query: nextProps.location.query }
                });
            }
        }
    }

    render() {
        return (
            <Provider store={GlobalStore}>
                <App {... this.props} />
            </Provider>
        );
    }
}
